window.blockOpsTimer;

(function(){
  var lastPositionTop,
    lastPositionLeft;

  PegasusTemplate.BlockOperationsView = Ember.View.extend({
    templateName: 'block_operations',
    classNames: ['select-operations'],
    classNameBindings: ['controller.content.isImmutable:immutable'],
    boundViewBinding: 'controller.content',
    isVisibleBinding: 'isOperable',
    attributeBindings: ['draggable'],

    draggable: "true",

    isOperableBinding: 'controller.isOperable',

    copyViewObserver: function(){
      Ember.run.scheduleOnce('afterRender', this, 'adjustDisplay');
    }.observes('controller.content'),

    mouseDown: function(e){
      Em.run(PegasusTemplate.lookupController('template'), 'set', 'draggingMuted', false);
    },

    mouseLeave: function(){
      lastPositionTop = null;
      lastPositionLeft = null;

      this.get('controller').send('hideOperations');
    },

    click: function( jqEvent ) {
      this.get('controller').send( 'editBlock' );
    },

    adjustDisplay: function(){
      var boundView, $boundView, $this, $row;
      var rowPosition, payloadPosition, boundViewPosition;
      var zoom = this.get('controller.zoomValue');

      boundView = this.get('boundView');
      $this = this.$();
      if ( !boundView || !$this ) { return; }

      $boundView = boundView.$();
      if ( boundView.get('row') ) {
        $row = boundView.get('row').$();
        rowPosition = $row.position();
      }
      var $payload = $boundView.find('.payload');

      if ( !$row || !$row.length ) {
        payloadPosition = $payload ? $payload.position() : {};

        var left = payloadPosition.left;
        var top = payloadPosition.top;

        var actualLeft = ((100*left) / (zoom*100)) * 100;
        var actualTop = ((100*top) / (zoom*100)) * 100;

        this.$().css({
          width: $boundView.outerWidth(),
          height: $boundView.outerHeight(),
          display: '',
          position: 'absolute',
          zIndex: 0,
          left: actualLeft,
          top: actualTop
        });

        return;
      }

      if ( ( lastPositionLeft !== rowPosition.left || lastPositionTop !== rowPosition.top ) ) {
        //$this.hide();
        lastPositionLeft = rowPosition.left;
        lastPositionTop = rowPosition.top;
        Em.run.scheduleOnce('afterRender', this, 'adjustDisplay');
        return;
      } else {
        $this.show();
        lastPositionLeft = null;
        lastPositionTop = null;
      }

      boundViewPosition = $boundView.position();

      var $container = $('.vr-canvas-instance').first();
      var containerLeftWidth = parseInt( $container.css('borderLeftWidth'), 10);
      var containerLeftWidthActual = ((100*containerLeftWidth) / (zoom*100)) * 100;
      var containerTopWidth = parseInt( $container.css('borderTopWidth'), 10);
      var containerTopWidthActual = ((100*containerTopWidth) / (zoom*100)) * 100;

      var borderLeftWidth = parseInt( $this.css('borderLeftWidth'), 10);
      var borderLeftWidthActual = ((100*borderLeftWidth) / (zoom*100)) * 100;
      var borderTopWidth = parseInt( $this.css('borderTopWidth'), 10);
      var borderTopWidthActual = ((100*borderTopWidth) / (zoom*100)) * 100;

      var left = containerLeftWidth + boundViewPosition.left + rowPosition.left - borderLeftWidthActual;
      var top  = containerTopWidth  + boundViewPosition.top + rowPosition.top - borderTopWidthActual;
      var actualLeft = ((100*left) / (zoom*100)) * 100;
      var actualTop = ((100*top) / (zoom*100)) * 100;

      this.$().customDragImage({
        offsetX: 50,
        offsetY: 50,
        createDragImage: function($node) {
          return $('<img>').
            attr('src', this.get('controller.row.previewImage')).
            attr('data-id', this.get('controller.row.elementId'))[0];
        }.bind(this)
      });

      this.$().css({
        width: $boundView.outerWidth(true),
        height: $boundView.outerHeight(true),
        display: '',
        position: 'absolute',
        zIndex: 0,
        left: actualLeft,
        top: actualTop
      });
    }
  });
})();
